import SharedLegalLayout from './layout'

/**
 * WaiverAndRelease
 *
 * The Waiver and Release page, linked to from the Course Acknowledgment page
 */
const WaiverAndRelease = () => (
  <SharedLegalLayout heading="Waiver And Release">
    <section>
      <p>
        I am an adult with the legal capacity to enter into this Agreement and make the covenants
        and uphold the obligations contained herein. I am participating in a training
        (&quot;Training&quot;), provided by Rescue X Training and Consulting, LLC
        (&quot;RescueX&quot;), together with additional third-party organizations that participate
        in trainings, herein jointly referred to as &quot;the Parties&quot; of my own choice and
        agree to all the terms and conditions of this Waiver and Release (&quot;Agreement&quot;).
      </p>
      <ol>
        <li>
          I expressly assume all risks of injury, including death, and all related damages which
          may occur in connection with my participation in the Training regardless of my or The
          Parties&apos; action, inaction, or negligence. I agree to assume all the foregoing risks
          and accept full responsibility for my own damages following such injury, disability, or
          death.
        </li>
        <li>
          I certify that I am physically fit, have sufficiently prepared for participation in this
          Training, and have not been advised to not participate by a qualified medical
          professional. I certify that there are no health-related reasons or problems which
          preclude my participation in this Training.
        </li>
        <li>
          I forever release, waive, discharge, and agree not to sue The Parties and all its
          respective agents, affiliates, associates, officers, directors, owners, contractors and
          employees (collectively &quot;Released Parties&quot;) for any and all claims, demands,
          losses, damages, suits, actions and expenses (including, without limitation, reasonable
          attorneys&apos; fees) on account of any bodily injury, death, or property or personal
          damage caused or alleged to be caused in whole or in part by the Released Parties or any
          other party&apos;s actions, inaction, or negligence in connection with my engagement with
          The Parties.
        </li>
        <li>
          I hereby indemnify and hold harmless the Released Parties from any and all third party
          claims, demands, losses, damages, suits, actions, and expenses caused in whole or in part
          by my actions, inaction, or negligence.
        </li>
        <li>
          In the event of any injury to me, I consent to any and all emergency medical care and
          transportation. The Parties and/or its authorized agents or representatives may deem
          appropriate. The release and waiver herein extends to any liability arising out of or in
          any way connected with the medical treatment and transportation provided in the event of
          an emergency.
        </li>
        <li>
          In the event of my inappropriate or disruptive behavior, The Parties and/or its
          authorized agents or representatives may exclude me from the Training and the Training
          premises. I release any and all claims against The Parties related to any discontinuation
          of my participation or involvement in the Training.
        </li>
        <li>
          I understand and agree that Rescue X does not warrant, guarantee, or make any
          representations about the Training. Rescue X disclaims all warranties with respect to the
          Training, either express, implied, or statutory, including but not limited to the implied
          warranties of merchantability, of satisfactory quality, of fitness for a particular
          purpose, and of accuracy.
        </li>
        <li>
          I understand and acknowledge that I am expected to take part in this Training annually
          for as long as I am using The Parties equipment or products, to ensure the proper skills
          and training to safely use said equipment or products. Failure to take part in this
          Training annually is at my own risk and I forever release, waive, discharge, and agree
          not to sue the Released Parties for any and all claims, demands, losses, damages, suits,
          actions, and expenses on account of my continued use of The Parties equipment or products
          without annual Training.
        </li>
        <li>
          This Agreement is governed by the laws of the State of Colorado and I agree to the
          exclusive jurisdiction of the courts in Denver, Colorado to resolve any dispute
          hereunder. Notwithstanding the foregoing, any dispute related to the Training or my use
          of any The Parties equipment that cannot be resolved by good faith negotiation shall be
          submitted to confidential, binding arbitration by a single arbitrator in accordance with
          the commercial rules of the American Arbitration Association in Denver, Colorado. Any
          resulting decision may be entered in a court having jurisdiction.
        </li>
        <li>
          I expressly agree that the terms of release and indemnity contained herein are intended
          to be as broad and inclusive as is permitted by the laws of the state of Colorado. If any
          portion of this Agreement is determined by a court of competent jurisdiction to be
          invalid or unenforceable, such portion will be enforced to the maximum extent permitted
          by law and the remainder of this Agreement will continue in full force and effect.
        </li>
      </ol>
      <p>
        I have read this entire Waiver and Release Agreement and understand all its contents,
        without exception. I understand that by agreeing to this Agreement, I am assuming all risk
        of engaging with The Parties and have given up substantial rights.
      </p>
    </section>
  </SharedLegalLayout>
)

export default WaiverAndRelease
